var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.52,9.91h-1.51v4.53c3.1-.49,5.47-3.17,5.47-6.4,0-3.58-2.9-6.48-6.48-6.48S1.52,4.46,1.52,8.04c0,3.23,2.37,5.92,5.47,6.4v-4.53h-1.65v-1.87h1.65v-1.43c0-.1,0-.2.01-.3.08-.98.54-1.66,1.27-1.99.34-.15.73-.23,1.17-.23.71,0,1.45.13,1.45.13v1.59h-.82c-.4,0-.67.12-.83.31-.16.19-.23.44-.23.7v1.22h1.8l-.29,1.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.34ec3458362924db1bad91c381ced7d6.svg";
export { ForwardRef as ReactComponent };